import { Action, Dispatch } from 'redux'
import { closeConfirmModalAction } from 'reducks/modal/actions'

const closeConfirmModal = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(closeConfirmModalAction())
  }
}

export default closeConfirmModal
